import {useState,useEffect,useMemo} from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import './SignUpPage.css'
import {SignUpUrl} from '../../Essentials/variables';
import logo from '../../assets/maruti-logo.png';
export default function SignUpPage(props){
const [data,setData] = useState({"category" : props.option});
const [password,setPassword] = useState('');
const [validation,setValidation] = useState(false);
const [response,setResponse] = useState('');
const [formDisabled,setFormDisabled] = useState(false);
useMemo(()=>{
    setData({...data , "password" : password});
},[password]);

const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setFormDisabled(true);
  
    fetch(SignUpUrl,{
        method : 'POST',
        headers: {
            'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-Frame-Options': 'DENY',
                        'Content-Security-Policy': "frame-ancestors 'none'",
                        'Feature-Policy': "frame-ancestors 'none'"
          },
          body: JSON.stringify(data)
        })
          .then(d => d.json()).then((res) => {
            setResponse(res)});
            props.nav('/login');
  };
    return(
        <div id="SignUp-container">
            <div id="banner"><img id="logo" src = {logo} alt="Maruti Logo" /></div>
            <div id="SignUpBox"><h4 style={{margin:"auto",width:"80%",paddingBottom:"15px",color: '#171b8f',
          'font-family': 'poppins',
          textAlign: 'Center'
          }}>Rural Management Potential Analysis Registration Form</h4>
             <Form  onSubmit={handleSubmit}>
            <Form.Group >
                <Form.Label>Enter your Employee ID / Dealer Code</Form.Label>
                <Form.Control disabled={formDisabled} id="userID" type="id" onChange={(e)=>{setData({...data , "id" : e.target.value})}} required/> 
            </Form.Group>
            <Form.Group>
                <Form.Label>Enter New Password</Form.Label>
                <Form.Control disabled={formDisabled} id="SignUpPassword" type="password" onChange={(e)=>{setPassword(e.target.value)}} required/> 
            </Form.Group>
            <Form.Group>
                <Form.Label>ReEnter New Password</Form.Label>
                <Form.Control disabled={formDisabled} id="SignUpRePassword" type="password" isValid={!!validation} isInvalid={!validation} onChange={(e)=>{e.target.value !== password ? setValidation(false) : setValidation(true)}} required/> 
                <Form.Control.Feedback type="valid">Your password is matched</Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">Your password is not matching</Form.Control.Feedback>
            </Form.Group>
            <Form.Group>
                <Form.Label>Enter your Email</Form.Label>
                <Form.Control disabled={formDisabled} id="email" type="email" onChange={(e)=>{setData({...data , "email" : e.target.value})}} required/> 
            </Form.Group>
            <Form.Group>
            <button id="submitBtn" disabled={formDisabled} type="submit">SignUp</button>
            </Form.Group>
            </Form>
            </div>
        </div>
    );
}